
import { defineAsyncComponent, defineComponent, PropType, ref } from 'vue';

import { ContentAccordinationModel } from '@/models/content_accordination_model';

import BaseStyle from './BaseStyle.vue';

export default defineComponent({
  name: 'ContentAccordination',
  components: {
    BaseStyle,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Content: defineAsyncComponent((): any => import('./Content.vue')),
  },
  props: {

    /**
     * Model
     */
    model: {
      type: Object as PropType<ContentAccordinationModel>,
      required: true,
    },
  },
  setup() {
    const opened = ref(false);
    return {
      opened,
    };
  },
});
